export default __webpack_public_path__ + "media/images/features/toyono/main_background_sp-02455f37e235f06b7085309e141a7130.png";